export default __webpack_public_path__ + "content/ed41bedf131bc097372a961dbec109a1.ttf";